<div *ngIf="uiPreferences$ | async as uiPreferences">
  <h3>UI Preferences</h3>
  <ul class="list-group list-group-flush">
    <li *ngFor="let preference of uiPreferences" class="list-group-item">
      <strong>{{ preference.name }}:</strong>
      {{ preference.value === null ? '-' : preference.value }}
    </li>
  </ul>
  <div *ngIf="uiPreferences.length === 0" class="no-preferences">
    No UI preferences set
  </div>
</div>
